"use client";

import { useTranslations } from "next-intl";
import { createContext, useContext } from "react";

type SubtitleMode = "subtitles" | "captions";
type HeroSubtitleMediaNamespace = "ClientKeys.SubtitleMedia";
type HeroCaptionMediaNamespace = "ClientKeys.CaptionMedia";

export interface ITranslationContext {
  t: ReturnType<typeof useTranslations<HeroSubtitleMediaNamespace>>;
}

export const HeroSubtitleMediaContext = createContext<ITranslationContext>({
  // @ts-expect-error - default replaced in provider
  t: () => "",
});

export function useHeroSubtitleMediaTranslations() {
  const ctx = useContext(HeroSubtitleMediaContext);
  if (!ctx) throw new Error("useHeroSubtitleMediaTranslations must be used within a HeroSubtitleMediaProvider");
  return ctx.t;
}

export function HeroSubtitleMediaProvider({
  children,
  mode = "subtitles",
}: {
  children: React.ReactNode;
  mode?: SubtitleMode;
}) {
  const t = useTranslations(`ClientKeys.${mode === "subtitles" ? "SubtitleMedia" : "CaptionMedia"}`);
  // Direct pass-through; no overrides needed for now
  const proxy = (...args: Parameters<ReturnType<typeof useTranslations<HeroSubtitleMediaNamespace>>>) => t(...args);
  // @ts-expect-error - proxy call signature matches t
  return <HeroSubtitleMediaContext.Provider value={{ t: proxy, mode }}>{children}</HeroSubtitleMediaContext.Provider>;
}
